import React, { useContext } from 'react';
import SubTitle from '../../../SubTitle';
import GasSchedule from './GasSchedule';
import CompressorStrategy from './CompressorStrategy';
import titleIcon from '@/assets/images/title_icon.png';
import { DoubleRightOutlined } from '@ant-design/icons';
import { Button } from '@maxtropy/components';
import { ShareDataWrapperContext } from '@/pages/WgqAllMaps';

const RightBox: React.FC = () => {
  const { isStandardSize, loadMap } = useContext(ShareDataWrapperContext);
  const isLargeNoMapLayout = !isStandardSize && !loadMap;

  return (
    <>
      <SubTitle
        title="供气日程表"
        img={titleIcon}
        style={{ flex: 'none', height: isLargeNoMapLayout ? 486 : 360, padding: 0 }}
        extraContent={
          <Button
            type="link"
            icon={<DoubleRightOutlined />}
            iconPosition="end"
            style={{ padding: 0 }}
            onClick={() => {
              window.open(`/energy/usage/gasSchedule`, '_blank');
            }}
          >
            查看全部
          </Button>
        }
      >
        <GasSchedule />
      </SubTitle>
      <SubTitle
        title="空压机策略"
        img={titleIcon}
        style={{ flex: 'none', height: 600 }}
        extraContent={
          <Button
            type="link"
            icon={<DoubleRightOutlined />}
            iconPosition="end"
            style={{ padding: 0 }}
            onClick={() => {
              window.open(`/power/monitoring/compressedAirOverview`, '_blank');
            }}
          >
            详情
          </Button>
        }
      >
        <CompressorStrategy />
      </SubTitle>
    </>
  );
};

export default RightBox;
